'use client';

import { ThemeEnum } from './Theme';
import ButtonUI from './Button';

const Button = ButtonUI<ThemeEnum.Site>;

export default Button;
